


















import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import { computed, defineComponent } from '@vue/composition-api';

export default defineComponent({
  props: {
    sender: { type: String, required: true },
  },
  setup(props) {
    const title = computed(() => `${props.sender} ${t('has-modified-the-document')}`);
    return { title };
  },
});
